import { useEffect } from 'react'

import { useMeetingManager } from 'amazon-chime-sdk-component-library-react'

type UseAttendeePresenceListenerProps = {
  selfId: string
  onJoin?: (attendeeId: string) => void
  onLeave?: (attendeeId: string) => void
}

export const useAttendeePresenceListener = ({
  selfId,
  onJoin,
  onLeave,
}: UseAttendeePresenceListenerProps) => {
  const meetingManager = useMeetingManager()

  useEffect(() => {
    const attendeePresenceCallback = (id: string, present: boolean) => {
      // Skip if it's our own presence event
      if (id === selfId) {
        return
      }

      if (present && onJoin) {
        onJoin(id)
      } else if (!present && onLeave) {
        // Prevent attendees from leaving the meeting room if they share the screen
        if (id.includes('#content')) {
          return
        }
        onLeave(id)
      }
    }

    // Set up attendee presence monitoring
    meetingManager.audioVideo?.realtimeSubscribeToAttendeeIdPresence(
      attendeePresenceCallback
    )

    // Cleanup
    return () => {
      meetingManager.audioVideo?.realtimeUnsubscribeToAttendeeIdPresence(
        attendeePresenceCallback
      )
    }
  }, [selfId, onJoin, onLeave, meetingManager.audioVideo])
}
